import { PortfolioItemModel } from "../../../features/portfolio-info/types/PortfolioItemModel";
import { blackScholesModelCalculationService } from "../BlackScholesModelCalculationService";
import { AssetType } from "../../types/AssetType";
import { mathCalculationService } from "../MathCalculationService";

export abstract class BaseCalculationService {
    calculateAtCurrent(portfolioItems: PortfolioItemModel[], underlyingPrice: number): number {
        let value = 0;

        portfolioItems.map(item => {
            if (item.isActive) {
                const timeToExpirationInShareOfYear = item.expireAt !== null
                    ? blackScholesModelCalculationService.getTimeToExpirationInShareOfYear(item.expireAt)
                    : null;
                
                value += this.calculate(item, underlyingPrice, timeToExpirationInShareOfYear);
            }
        });

        return value;
    }

    calculateAtCustom(portfolioItems: PortfolioItemModel[], underlyingPrice: number, customDate: Date): number {
        let value = 0;

        portfolioItems.map(item => {
            if (item.isActive) {
                const timeToExpirationInShareOfYear = item.expireAt !== null
                    ? blackScholesModelCalculationService.getTimeToExpirationInShareOfYear(item.expireAt, customDate)
                    : null;
                
                value += this.calculate(item, underlyingPrice, timeToExpirationInShareOfYear);
            }
        });

        return value;
    }

    calculateAtExpiration(portfolioItems: PortfolioItemModel[], underlyingPrice: number): number {
        let value = 0;

        portfolioItems.map(item => {
            if (item.isActive) {
                value += this.calculate(item, underlyingPrice, this.getMinTimeToExpirationInShareOfYear());
            }
        });

        return value;
    }

    calculate(item: PortfolioItemModel,
              underlyingPrice: number, timeToExpirationInShareOfYear: number | null
    ): number {
        if (item.type === AssetType.Futures || item.type === AssetType.Spot) {
            return this.calculateForFutures(item);
        } else if (item.type === AssetType.Call || item.type === AssetType.Put) {
            if (timeToExpirationInShareOfYear === null) {
                throw new Error("Arg 'timeToExpirationInShareOfYear' is null.")
            }

            return this.calculateForOption(item, underlyingPrice, timeToExpirationInShareOfYear) * item.size;
        }

        throw new Error("Unknown AssetType");
    }
    
    protected abstract calculateForFutures(item: PortfolioItemModel): number;

    protected abstract calculateForOption(item: PortfolioItemModel,
        underlyingPrice: number, timeToExpirationInShareOfYear: number
    ): number;

    protected getMinTimeToExpirationInShareOfYear(): number {
        return 0;
    }

    protected round(value: number, precision: number): number {
        return mathCalculationService.round(value, precision);
    }
}